// extracted by mini-css-extract-plugin
export default {"input":"input__KhC0w","__size-small":"__size-small__ha0d8","__size-default":"__size-default__WPGlS","__size-accent":"__size-accent__i4Aau"};